import { format } from 'date-fns'

import { determineValueChange } from 'app/common/presentation'
import { formatDate, formatNumber } from 'app/common/presentation/format'
import { DaySessions } from 'app/dashbaord/types'

import { Chart, PercentageIndicator } from 'components'

import { tooltipDateFormat } from '../Dashboard'
import Tile, { TileContentProps } from './Tile'
import styles from './Tile.module.scss'

interface SessionsProps extends TileContentProps {
  sessions: DaySessions[]
}

const Sessions = ({ days, sessions, translate }: SessionsProps) => {
  const totalSessions = sessions.reduce((acc, session) => acc + session.total, 0)
  const totalSessions30DaysBefore = sessions.reduce(
    (acc, session) => acc + (session.total30DaysBefore ?? 0),
    0,
  )
  const change = determineValueChange([totalSessions, totalSessions30DaysBefore])

  return (
    <Tile className={styles.sessions} days={days} tileKey="sessions" translate={translate}>
      <div className={styles.sessions}>
        <Chart.AreaChart
          data={sessions.map((entry) => ({ key: entry.date, value: entry.total }))}
          formatTooltipLabel={(date) => format(date, tooltipDateFormat)}
          formatXTick={formatDate}
          formatYTick={(value) => formatNumber(value)}
          reversed
          yScaleFactor={1.5}
        />
        <div className={styles.chartInfo}>
          <div className={styles.total}>{formatNumber(totalSessions)}</div>
          <PercentageIndicator percentage={change} />
        </div>
      </div>
    </Tile>
  )
}

export default Sessions
